import ProductSelection from "../domains2/orders/ProductSelection";
import appConfig from "../appconfig";
import {evaluateCustomerType} from "../libraries/utils";
import {convertProductSelectionsToMap} from "../helper/ProductSelectionHelper";

export default {
	methods: {
		generateOrderLines(products) {
			if(!products || !Array.isArray(products) || products.length === 0) {
				return [];
			}
			return ProductSelection.mapToOrderLinesGx(appConfig.getBusinessModelId())(
				this.productCatalog,
				products,
				false,
				{
					vouchers: this.$store.getters.vouchersRedeemed,
					employeeDiscountToken: this.$store.getters.employeeDiscountToken,
					sunsetPoints: this.$store.getters.sunsetPoints,
					dailySpending: this.$store.getters.featureToggles.discountDailyLimit
						? this.$store.getters.applicationUserData && this.$store.getters.applicationUserData.meta.dailySpending
						: {},
					channel: appConfig.channelAlias(),
					deliveryMethod: this.$store.getters.tenantSpecificData.deliveryChoice,
					customerType: evaluateCustomerType(),
					cartProductsMap: convertProductSelectionsToMap(this.$store.getters.cartProducts)
				},
				this.$store.getters.tenantSpecificData.cartOrderTags
			)
				.filter(ol => ol.type !== "Meta");
		}
	}
};
